import { reducerFromMap } from "../../libs/helpers/reducers";

import {
  FEE_SERVICE_LOADING,
  FEE_SERVICE_LOADED,
  FEE_SERVICE_LOAD_ERROR,
  FEE_SERVICE_CREATE_LOADING,
  FEE_SERVICE_CREATE_LOAD_ERROR,
  FEE_SERVICE_EDIT_LOADING,
  FEE_SERVICE_EDIT_COMPLETE,
  FEE_SERVICE_EDIT_LOAD_ERROR,
  FEE_SERVICE_DELETE_LOADING,
  FEE_SERVICE_DELETE_COMPLETE,
  FEE_SERVICE_DELETE_LOAD_ERROR,
  FEE_SERVICE_CREATE_COMPLETE,
} from "../../actions/registry/registry.fee_service.actions";

const reducer = {
  /*
   * FEE_SERVICE LIST
   */
  [FEE_SERVICE_LOADING]: (state) => ({
    ...state,
    loading: true,
  }),
  [FEE_SERVICE_LOADED]: (state, { data }) => ({
    ...state,
    loading: false,
    data: data.data,
  }),
  [FEE_SERVICE_LOAD_ERROR]: (state, { data }) => ({
    ...state,
    loading: false,
    error: data,
  }),
  /*
   * FEE_SERVICE CREATE
   */
  [FEE_SERVICE_CREATE_LOADING]: (state) => ({
    ...state,
    loading: true,
  }),
  [FEE_SERVICE_CREATE_COMPLETE]: (state, { data }) => ({
    ...state,
    loading: false,
  }),
  [FEE_SERVICE_CREATE_LOAD_ERROR]: (state, { data }) => ({
    ...state,
    loading: false,
    error: data,
  }),
  /*
   * FEE_SERVICE EDIT
   */
  [FEE_SERVICE_EDIT_LOADING]: (state) => ({
    ...state,
    loading: true,
  }),
  [FEE_SERVICE_EDIT_COMPLETE]: (state, { data }) => ({
    ...state,
    loading: false,
  }),
  [FEE_SERVICE_EDIT_LOAD_ERROR]: (state, { data }) => ({
    ...state,
    loading: false,
    error: data,
  }),
  /*
   * FEE_SERVICE DELETE
   */
  [FEE_SERVICE_DELETE_LOADING]: (state) => ({
    ...state,
    fee_service: { ...state.fee_service, loading: true },
  }),
  [FEE_SERVICE_DELETE_COMPLETE]: (state, { data }) => ({
    ...state,
    loading: false,
  }),
  [FEE_SERVICE_DELETE_LOAD_ERROR]: (state, { data }) => ({
    ...state,
    fee_service: { ...state.fee_service, loading: false },
    error: data,
  }),
};

export default reducerFromMap(reducer, {
  data: [],
});
